<template>
  <router-view
    v-if="project && projectData"
    :project-data="projectData"
    :project="project"
  />
</template>

<script>
export default {
  data: () => ({
    project: null,
    projectData: null
  }),
  pouch: {
    projectData: function () {
      return {
        database: 'project_data',
        selector: { _id: this.$route.params.id },
        first: true
      };
    }
  },
  watch: {
    projectData (v) {
      (async () => {
        this.project = await this.$pouch.get('' + this.projectData.projectId, {}, 'projects');
      })();
    }
  }
};
</script>
